import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { ProductName } from "@zp-models/product";
import { StateService } from "@zp-services/state.service";

@Component({
  standalone: true,
  selector: "app-aanvragen-wizard",
  templateUrl: "./aanvragen.component.html",
  imports: [RouterOutlet, TranslateModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AanvragenComponent implements OnInit {
  orderedProduct: ProductName;
  constructor(private stateService: StateService) {}

  ngOnInit() {
    this.orderedProduct = this.stateService.getOrderedProduct();
  }
}
